import { authenticatedPost } from '../../api/request';

export default async function createDoctorAppointment(data, setError) {
   const onFail = () => setError('Hubo un error creando la cita, por favor intente de nuevo');

   return await authenticatedPost(
    `/appointment-user/create`, onFail, data
   );
}
